import React from 'react';

export default function Tick() {
  return (
    <svg viewBox="0 0 14.84 10.21" width="14" height="14">
      <path
        id="check"
        d="M7,9.5a2.29,2.29,0,0,1-3.32,0L.35,6.18A1.16,1.16,0,0,1,0,5.34a1.15,1.15,0,0,1,.36-.83,1.13,1.13,0,0,1,.83-.35A1.16,1.16,0,0,1,2,4.51L5.34,7.84,12.82.35a1.17,1.17,0,0,1,1.67,0,1.17,1.17,0,0,1,0,1.67Z"
      />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/Icons/Tick/index.js